<template>
    <slot v-bind="{
        ...state,
    }" />
</template>

<script setup>
import { onBeforeMount, reactive } from 'vue';

import { getSeriesBookingState } from '../services/booking';

const props = defineProps({
    subscriptionPackageId: {
        type: Number,
    },
    useBestAvailable: {
        type: Boolean,
        default: false,
    },
});

const state = reactive({
    isLoading: true,
    bookingState: null,
});

onBeforeMount(() => {
    getSeriesBookingState(props.subscriptionPackageId, props.useBestAvailable).then(response => {
        state.bookingState = response;
    }).finally(() => {
        state.isLoading = false;
    });
});
</script>
